
riot.tag2('modifications-list', '  <catalog object="Modification" cols="{cols}" allselect="true" reload="true" handlers="{handlers}" store="modifications-list" add="{permission(add, &quot;products&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" dblclick="{permission(open, &quot;products&quot;, &quot;1000&quot;)}">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="vtype">{handlers.types[row.vtype]}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'Modification';

self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'vtype', value: 'Тип ценообразования' }];

self.handlers = {
    types: {
        "0": 'Добавляет к цене',
        "1": 'Умножает на цену',
        "2": 'Замещает цену'
    }
};

self.add = function () {
    riot.route('products/modifications/new');
};

self.open = function (e) {
    riot.route('products/modifications/' + e.item.row.id);
};

observable.on('modifications-reload', function () {
    return self.tags.catalog.reload();
});
});


// WEBPACK FOOTER //
// ./pages/products/modifications/modifications-list.tag